import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import your images
import img1 from "../Assets/Performance/performance0.jpeg";
import img2 from "../Assets/Performance/performance1.jpeg";
import img3 from "../Assets/Performance/performance2.jpeg";
import img4 from "../Assets/Performance/performance3.jpeg";
import img5 from "../Assets/Performance/performance4.jpeg";
import img6 from "../Assets/Performance/performance5.jpeg";

const OurWork = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 2500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 },
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1 },
            },
        ],
    };

    const images = [img1, img2, img3, img4, img5, img6];

    return (
        <section className="w-full bg-[#FFF] py-16 px-4 sm:px-6 lg:px-12 2xl:px-32 mt-[5%]">

            <div className="max-w-screen-2xl mx-auto">

                {/* Heading */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black">
                        Our <span className="text-yellow-400">Performance Results</span>
                    </h2>

                    <p className="text-gray-400 mt-4 text-sm sm:text-base max-w-2xl mx-auto">
                        Real campaign results showcasing growth in traffic, leads, and conversions
                        through strategic SEO and paid advertising.
                    </p>
                </div>

                {/* Slider */}
                <Slider {...settings}>
                    {images.map((img, index) => (
                        <div key={index} className="px-3">
                            <div className="rounded-2xl overflow-hidden shadow-lg bg-white flex items-center justify-center">

                                {/* Image Wrapper */}
                                <div className="w-full h-[260px] sm:h-[340px] flex items-center justify-center">
                                    <img
                                        src={img}
                                        alt={`performance-${index}`}
                                        className="max-h-full max-w-full object-contain transition duration-500"
                                    />
                                </div>

                            </div>
                        </div>
                    ))}
                </Slider>

            </div>
        </section>
    );
};

export default OurWork;